import styled from 'styled-components';


export const Header = styled.div`
  background: var(--accent);
  color: var(--text-on-accent);
  width: 2690px;
  height: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-left: 32px;


  font-family: Verdana, Geneva, sans-serif;
  font-size: 25px;
  letter-spacing: 1.5px;
  word-spacing: 2px;
  font-weight: normal;
  text-decoration: var(--text-muted);
`;

export const Container = styled.div`
  display: flex;
  background: var(--surface-2);
  width: 98vw;
`;

export const Column = styled.div`
  width: 300px;
  background-color: var(--surface-1);
  margin-right: 8px;
  position: relative;
  border-radius: 5px;
  padding: 5px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;


  h4 {
    text-align: center;
    min-height: 30px;
    border-bottom: 1px solid var(--border-default);
    font-weight: 400;
    font-size: 12pt;
    color: var(--accent);
    margin-bottom: 25px;
  }

`;

export const CardContainer = styled.div`
  background-color: ${(props) => props.showingColumn ? 'var(--danger)' : 'var(--surface-1)'};
  border-radius: 5px;
  padding: 10px;
  cursor: move;
  border-radius: 5px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-sm);
  width: 90px;

  h3 {
    color: ${(props) => props.scoreColor};
  }
`;
